module.exports = __webpack_public_path__ + "img/visi_misi.0986735e.png";